export default __webpack_public_path__ + "static/media/hero_8.99cb1700.png";